import { type ReactNode } from 'react';

import AppProviders from '@app/components/AppProviders';
import GlobalStyles from '@app/globalStyles';

type AppProvidersProps<TTwigContext> = {
    children: ReactNode | readonly ReactNode[];
    twigContext?: TTwigContext;
};

const PageRoot = <TTwigContext extends Record<string, unknown> = Record<string, unknown>>({
    children,
    twigContext,
}: AppProvidersProps<TTwigContext>) => (
    <AppProviders twigContext={twigContext}>
        <GlobalStyles />
        {children}
    </AppProviders>
);

export default PageRoot;
